module.exports = __webpack_public_path__ + "static/rowDragging-4f33c055f15b102dcdd8f041cb51421e.gif";